<template>
  <v-widget
    :title="$t('User Roles')"
    class="mb-4"
  >
    <div slot="widget-header-action">
      <v-btn
        flat
        class="text--secondary text-capitalize"
        @click="addRolesDialog=true"
      >
        {{ $t('Add Roles') }}
      </v-btn>
    </div>

    <div slot="widget-content">
      <v-flex>
        <v-text-field
          v-model="search"
          :label="$t('Search')"
          append-icon="search"
          single-line
          hide-details
        />
      </v-flex>

      <v-data-table
        :items="user.roles"
        :headers="headers"
        :search="search"
        :rows-per-page-text="$t('Rows per page')"
        item-key="name"
      >
        <template v-slot:items="{ item }">
          <tr>
            <td>{{ item.name }}</td>
            <td>{{ item.code }}</td>
            <td class="text-xs-right">
              <v-icon
                color="red"
                small
                @click="deleteRole(item)"
              >
                delete
              </v-icon>
            </td>
          </tr>
        </template>
        <template v-slot:pageText="props">
          <span>{{ $t('{0} - {1} of {2}', [props.pageStart, props.pageStop, props.itemsLength]) }}</span>
        </template>
      </v-data-table>

      <AddRelationDialog
        :dialog="addRolesDialog"
        :headers="rolesDialogHeaders"
        :fields="rolesDialogFields"
        :selected="user.roles"
        :model-get-request-config="rolesGetRequestConfig"
        :title="$t('Add Roles')"
        model="auth:role"
        @relation-items-added="addRoles"
        @dialog-closed="addRolesDialog=false"
      />
    </div>
  </v-widget>
</template>

<script>
import AddRelationDialog from '@/vuetify-console/components/AddRelationDialog'

export default {
  name: 'UserRoles',

  components: {
    AddRelationDialog
  },

  props: {
    user: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      menu: false,
      search: '',
      addRolesDialog: false,
      rolesDialogFields: [
        { name: 'name', format: 'string' },
        { name: 'email', format: 'string' },
        { name: 'type', format: 'string' }
      ],
      rolesGetRequestConfig: {
        headers: { 'x-user-type': 'admin' }
      }
    }
  },

  computed: {
    headers () {
      return [
        { text: this.$t('Name'), value: 'name' },
        { text: this.$t('Email'), value: 'email' },
        { text: this.$t('Type'), value: 'type' }
      ]
    },

    rolesDialogHeaders () {
      return [
        { text: this.$t('Name'), value: 'name' },
        { text: this.$t('Email'), value: 'email' },
        { text: this.$t('Type'), value: 'type' }
      ]
    }
  },

  methods: {
    deleteRole (role) {
      this.user.roles = this.user.roles.filter(e => e.id !== role.id)
      this.$forceUpdate()
    },

    addRoles (roles) {
      this.user.roles = this.user.roles ? this.user.roles.concat(roles) : roles
      this.addRolesDialog = false
    }
  }
}
</script>
